import React, { useEffect } from 'react'
import { useToken } from '../hooks'

interface TokenExchangeGuardProps {
	children: React.ReactNode
}

/**
 * TokenExchangeGuard
 *
 * 접속기에서 ssotoken으로 재접속 시 기존 토큰을 클리어합니다.
 * 토큰 클리어 후 LoginPage에서 새 토큰으로 SecureOn 검증 + 로그인 처리합니다.
 */
const TokenExchangeGuard: React.FC<TokenExchangeGuardProps> = ({ children }) => {
	const { data: token, mutate } = useToken()

	useEffect(() => {
		const params = new URLSearchParams(window.location.search)
		const ssotoken = params.get('ssotoken')
		const authKey = params.get('auth')

		// 접속기에서 auth 또는 ssotoken으로 접속 시 기존 토큰 클리어
		// → routes.tsx에서 LoginPage로 라우팅
		// → LoginPage에서 새 토큰으로 SecureOn 검증 후 로그인 처리
		const isFromLauncher = (ssotoken && ssotoken !== '0' && ssotoken !== 'null') || !!authKey
		if (isFromLauncher && token) {
			console.log('[TokenExchangeGuard] 접속기 재접속 - 기존 토큰 클리어')
			localStorage.removeItem('app-cache')
			mutate(null)
		}
	}, []) // mount only - 재접속 시 1회만 실행

	return <>{children}</>
}

export default TokenExchangeGuard
